<content-loading *ngIf="isLoading"></content-loading>
<form autocomplete="off" *ngIf="!isLoading" class="form pt-4">
  <property-photo-gallery
    *ngIf="imageBasePath"
    [images]="hasProperty ? propertyImages : images"
    [imageTypes]="imageTypes"
    (upload)="upload($event)"
    (delete)="delete($event)"
    [shouldReload]="shouldReload"
    [imageBaseUrl]="imageBasePath"
    [editable]="businessId"
    [isReadonly]="hasProperty || hasReadonlyPermission"
  ></property-photo-gallery>
</form>
